import React, { useContext } from 'react'
import LanguageIcon from '@mui/icons-material/Language';
import logo from '../assets/logo.png'
import { settingsContext } from '../Context/settingsProvider';
import { Link } from 'react-router-dom';



export default function Footer() {
    const {setChooseLang, t} = useContext(settingsContext)
    const links = {
        c1: [
            {link: '/', title: 'About'},
            {link: '/', title: 'Contact'},
        ],
        c2: [
            // {link: '/', title: 'Community'},
            {link: '/privacy', title:  t('PRIVACY_POLICY')},
            {link: '/terms', title:  t('TERMS')},
            {link: 'tel:+251962444466', title: '+251962444466'},
            {link: 'mailto:contact@hulluware.com', title: 'contact@hulluware.com'}
        ]
    }
   

    return (
        <div className='flex flex-col w-full bg-black'>
            <div className='flex flex-1 p-5'>
                <div className='flex justify-evenly max-md:flex-col max-md:items-center w-full max-md:gap-4'>
                    <div className=''>
                        <div className='flex items-center gap-1 flex-col'>
                            <img src={logo} className='w-[40px] object-contain' />
                            <p className='text-white text-xs text-center pb-5 pt-5 w-[400px] max-md:w-[300px] self-center text-justify'>
                                Hulluware is an eLearning platform for Ethiopia that empowers both institutes/Individuals and learners to thrive in the digital age. With zero upfront costs, institutes and individuals can seamlessly bring their courses online while we handle tech, security, and marketing. Students gain access to high-quality, engaging, and secure learning experiences—online.
                                🚀 Join Hulluware today. learn, teach, and grow!
                            </p>
                        </div>
                    </div>
                    {/* <div className='flex flex-col gap-2 max-md:items-center'>
                        {links.c1.map(item => (
                            <Link className='text-white text-sm no-underline' to={item.link}>{item.title}</Link>
                        ))}
                    </div> */}
                    <div className='flex gap-3 items-center max-md:flex-col max-md:gap-1'>
                        {links.c2.map(item => (
                            <Link className='text-white text-sm no-underline' to={item.link}>{item.title}</Link>
                        ))}
                    </div>
                </div>
                {/* <button className='text-white outline-none border-none' onClick={() => setChooseLang(true)}>
                    <LanguageIcon style={{color: 'white', fontSize: 25}}>Filled</LanguageIcon>  
                </button> */}
            </div>
            
            <p className='text-white text-xs text-center pb-5 pt-5'>&#169; ፳፻፲፯ Hulluware, {t('ALL_RIGHTS_RESERVED')} <br />Hulluware Technologies</p>
        </div>
    )
}
